import { render, staticRenderFns } from "./StatsBox.vue?vue&type=template&id=aa7a6292&"
import script from "./StatsBox.vue?vue&type=script&lang=js&"
export * from "./StatsBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports